import ProviderAPI from "../redux/ProviderAPI";


export const getYachtInformation = async (data, token) => {
    const result = await ProviderAPI({
      type: "GET",
      url: "yachtInformation/detailYachtInformation",
      data,
      token,
    });
   
    return result;
  };
    